import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDoneAllSvg } from "./IconDoneAllSvg.mjs";
const IconDoneAll = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDoneAllSvg, ...iconProps });
};
export {
  IconDoneAll
};
